var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Row, Col } from "react-bootstrap";
import authentication from "@irati/auth";
import { StyledCard, StyledHr } from "../styled";
import PerksSavingsBlock from "../../../components/ReportingV2/Perks/PerksSavingsBlock";
import PerksActivityChart from "../../../components/ReportingV2/Perks/PerksActivityChart";
import MostPopularPerks from "../../../components/ReportingV2/Perks/MostPopularPerks";
var PerksActivityAndSavings = /** @class */ (function (_super) {
    __extends(PerksActivityAndSavings, _super);
    function PerksActivityAndSavings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PerksActivityAndSavings.prototype.render = function () {
        var perksAndPerksGoMetrics = this.props.perksAndPerksGoMetrics;
        var isPerksGoEnabled = authentication.apps("perks.perksGo");
        var currency = authentication.defaultUserCurrency();
        return (React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(StyledHr, null),
                React.createElement(StyledCard, null,
                    React.createElement(PerksActivityChart, { perksAndPerksGoMetrics: perksAndPerksGoMetrics })),
                React.createElement(PerksSavingsBlock, { perksAndPerksGoMetrics: perksAndPerksGoMetrics, isPerksGoEnabled: isPerksGoEnabled }),
                React.createElement(MostPopularPerks, { perksAndPerksGoMetrics: perksAndPerksGoMetrics, isPerksGoEnabled: isPerksGoEnabled, currency: currency, countColumnId: "redemption_count", countColummTitle: "admin.reportingV2.popularPerks.title" }))));
    };
    return PerksActivityAndSavings;
}(PureComponent));
export default PerksActivityAndSavings;
